import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { ChallengeService } from '../../services/challenge.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'challenge-detail',
    templateUrl: './challenge-detail.component.html',
    styleUrls: ['./challenge-detail.component.scss']
})
export class ChallengeDetailComponent implements OnInit, OnDestroy {

    @Input()
    challenge: any;

    @Input()
    formGroup!: FormGroup;

    @Output('refreshChallenges')
    refreshEventEmitter = new EventEmitter<void>();

    deleteChallengeDetailVisible!: boolean;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private challengeService: ChallengeService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    displayDeleteChallengeDetail() {
        this.deleteChallengeDetailVisible = true;
        setTimeout(() => this.deleteChallengeDetailVisible = false, 3000);
    }

    deleteChallengeDetail() {
        this.progressIndicatorService.progress = true;
        this.challengeService.deleteChallengeLocale(this.challenge.id, this.formGroup.value.challengeDetailLocaleInput).subscribe({
            next: (value: any) => {
                console.log('ChallengeDetailComponent.deleteChallengeDetail.challengeService.deleteChallengeLocale.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('ChallengeDetailComponent.deleteChallengeDetail.challengeService.deleteChallengeLocale.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    emitRefreshEvent() {
        this.refreshEventEmitter.emit();
    }
}
